import React, { useEffect, useState } from 'react';
import { Col, Form, notification, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useHistory, useParams } from 'react-router';
import moment from 'moment';
import { useQuery } from 'react-query';
import { ThunderboltTwoTone } from '@ant-design/icons';
import { isNil, sumBy } from 'lodash';
import { ArrowLeftOutlined } from '@ant-design/icons';
import DF from '../../../DisplayFramework';
import DocList from '../../Document/DocList';
import Button from 'components/Button';
import SaveButton from 'components/SaveButton';
import WizardTabs from 'components/WizardTabs';
import Page, { PageModalProps } from 'components/Page';
import {
  getSupplierInvoiceById,
  createSupplierInvoice,
  updateSupplierInvoice,
  getSASSupplierInvoiceById,
} from 'services/supplierInvoice';
import TabSupplierInvoice from './components/tabSupplierInvoice';
import TabSuppInvoiceLines from './components/tabSuppInvoiceLines';
import TabSuppInvoiceSchedules from './components/tabSuppInvoiceSchedules';
import TabImportInvoice from './components/tabImportInvoice';
import TabSupplierInvoiceNetting from './components/tabSupplierInvoiceNetting';
import { shouldUpdateCompare, toDatePickerDate } from '../../../utils/utils2';
import TasksListPopover from '../../workflow/TasksListPopover';
import Accounting from 'components/Accounting';
import Title from 'components/Title';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import { useLocation } from 'react-router-dom';
import { getMyWizards } from 'services/workflow';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IActions from 'icons/IActions';

type SIDetailProps = PageModalProps & {
  siid?: number;
  suppliertInvoiceProp?: any;
  showButtons?: boolean;
  isCreateSI?: boolean;
};

const SIDetail = (props: SIDetailProps) => {
  const {
    suppliertInvoiceProp,
    visible = false,
    onCancel,
    showAsModal = false,
    showButtons,
    isCreateSI,
  } = props;

  const [form] = useForm();
  const history = useHistory();
  const { id } = useParams<{
    id: string;
  }>();

  const isCreate = id === 'create' || isCreateSI;
  form.setFieldsValue({ isCreate: isCreate });

  const SupplierPhase = (): 'SI' | 'SAS' => {
    try {
      const search = useLocation().search;
      const phase = new URLSearchParams(search).get('phase');
      if (!phase) {
        return 'SI';
      } else {
        return phase as 'SAS' | 'SI';
      }
    } catch (exception) {
      return 'SI';
    }
  };
  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);

  const ctPhase = SupplierPhase();
  const getsupplierInvoiceId = () => {
    const siid = props.siid ? props.siid : id;

    if (isCreate || !siid) {
      return;
    }
    return Number(siid);
  };
  const siid = getsupplierInvoiceId();

  const useSIDetail = (siid: any, ctPhase: string) => {
    const finSupplierQuery = useQuery(
      ['getSupplierInvoiceById', siid],
      () =>
        getSupplierInvoiceById({ siid: Number(siid) }).then((res) => {
          if (res.code === '403') {
            history.push('/403');
          }
          return res.data;
        }),
      {
        enabled: siid !== undefined && ctPhase === 'SI',
      }
    );
    const finSaasQuery = useQuery(
      ['getSASSupplierInvoiceById', siid],
      () =>
        getSASSupplierInvoiceById({ siid: Number(siid) }).then((res) => {
          if (res.code === '403') {
            history.push('/403');
          }
          return res.data;
        }),
      { enabled: !isNil(siid) && ctPhase === 'SAS' }
    );
    return ctPhase === 'SI' ? finSupplierQuery : finSaasQuery;
  };

  const { data, refetch: refecthst } = useSIDetail(siid, ctPhase);

  const tabPosition = localStorage.getItem('tabposition');

  const { refetch } = useQuery([]);

  // const { data, refetch: refecthst } = useQuery(
  //   ['getSupplierInvoiceById', siid],
  //   () =>
  //     getSupplierInvoiceById({ siid: Number(siid) }).then((res) => res.data),
  //   {
  //     enabled: siid !== undefined,
  //   }
  // );
  const refresh = () => {
    refetch();
  };
  const supplierInvoice = suppliertInvoiceProp ?? data;

  const { data: wizData } = useQuery(['getMyWizards', 'SINVOICE'], () =>
    getMyWizards({ entity: 'SINVOICE' }).then((res) => res.data)
  );

  useEffect(() => {
    if (supplierInvoice) {
      form.setFieldsValue({
        ...supplierInvoice,
        flagcn:
          !isNil(supplierInvoice.siidcreditnote) &&
          supplierInvoice.sistatus !== 'CREDITNOTE'
            ? true
            : false,
        // flagmulti: false,
        supplier: {
          tpname: supplierInvoice.suppliername,
          tpreference: supplierInvoice.tprefsupplier,
          tpid: supplierInvoice.tpidsupplier,
        },
        tppid: supplierInvoice.tpidsupplier,
        siltype:
          supplierInvoice.sitype === 'FEES' ||
          supplierInvoice.sitype === 'EXPENSE'
            ? 'Fees'
            : 'Asset',
        silnettotalamount: sumBy(
          supplierInvoice.suppInvoiceLines,
          'silnettotalamount'
        ),
        sidocdate: toDatePickerDate(supplierInvoice?.sidocdate),
        deliverydate: toDatePickerDate(supplierInvoice?.deliverydate),
        orderdate: toDatePickerDate(supplierInvoice?.orderdate),
        sisamount: sumBy(supplierInvoice.suppInvoiceSchedules, 'sisamount'),
        accountingdate: moment(supplierInvoice.accountingdate).format(
          'YYYY-MM-DD'
        ),
      });
    }
  }, [supplierInvoice, form]);
  const [refetechnetting, setrefetechnetting] = useState(false);

  const onFinish = (values: any) => {
    setLoadingBtn(true);
    const sigrosstotal = form.getFieldValue('sigrosstotal');
    // const sinettotal = form.getFieldValue('sinettotal');
    const sitaxtotal = form.getFieldValue('sitaxtotal');
    const ctrid =
      form.getFieldValue('ctrid') === -1 ? null : form.getFieldValue('ctrid');
    const suppInvoiceSchedules = form.getFieldValue('suppInvoiceSchedules');

    const suppInvoiceLines = form
      .getFieldValue('suppInvoiceLines')
      .map((siLine: any) => {
        return { ...siLine, ctrid: siLine.ctrid };
      });
    const sidueamount = form.getFieldValue('sigrosstotal');
    const sisamount = form.getFieldValue('sisamount');
    const sistatus = form.getFieldValue('sistatus');
    const tpidsupplier =
      form.getFieldValue('supplier').tpid ?? form.getFieldValue('tppid');
    const sidocdate = form.getFieldValue('sidocdate');
    const ctreference =
      // form.getFieldValue('ctreferenceprops') ||
      form.getFieldValue('ctreference');
    const orderdate = form.getFieldValue('orderdate');
    const deliverydate = form.getFieldValue('deliverydate');
    const orderreference = form.getFieldValue('orderreference') ?? '';
    const deliveryreference = form.getFieldValue('deliveryreference') ?? '';
    const sitype = form.getFieldValue('sitype');
    const simultiplecontracts = form.getFieldValue('simultiplecontracts')
      ? form.getFieldValue('simultiplecontracts')
      : false;

    const data = {
      ...values,
      sinettotal: form.getFieldValue('silnettotalamount'),
      siid: siid || '',
      suppInvoiceLines,
      suppInvoiceSchedules,
      ctrid,
      sistatus,
      ctreference,
      sigrosstotal,
      sitaxtotal,
      sitype,
      simultiplecontracts,
      sireference: form.getFieldValue('sireference') ?? '',
      tpidsupplier,
      tprefsupplier: '',
      tprefclient: '',
      tpidclient:
        form
          .getFieldValue('suppInvoiceLines')
          .find((line: any) => !isNil(line.tpidclient))?.tpidclient ?? '',
      mgid: localStorage.getItem('mgid'),
      tpdeliveryaddress: null,
      tpdeliveryaddress2: null,
      tpdeliveryzipcode: null,
      tpdeliverycity: null,
      tpinvoicingaddress: null,
      tpinvoicingaddress2: null,
      tpinvoicingzipcode: null,
      tpinvoicingcity: null,
      orderreference,
      deliveryreference,
      sipaymentdelaycode: null,
      sipaymentdate: null,
      sipaymentmode: null,
      sidueamount,
      siidcreditnote: 0,
      accountingreference: null,
      creditnote: '',
      statuslabel: '',
      sicomplevel: form.getFieldValue('sicomplevel') ?? false,
      sidocdate,
      orderdate,
      deliverydate,
      accountingdate: toDatePickerDate(moment().format('YYYY-MM-DD')),
      last_action: Number(siid)
        ? wizData?.taskidUpdate ?? 0
        : wizData?.taskidCreate ?? 0,
    };
    if (suppInvoiceLines.length === 0) {
      notification.error({
        message: 'Error validating input',
        description: 'Please add Supplier Invoice Line',
      });
      return;
    }

    if (sigrosstotal !== sisamount) {
      notification.error({
        message: 'Error validating input',
        description:
          'The total Payment Shcedule and the Total lines are different. please check',
      });
      return;
    }

    if (siid) {
      updateSupplierInvoice({ supplierInvoiceRequest: data, siid: siid })
        .then((res) => {
          setLoadingBtn(false);
          notification.success({
            message: res.message,
            description: res.description,
          });
        })
        .catch(() => {
          setLoadingBtn(false);
        });
    } else {
      createSupplierInvoice({ supplierInvoiceRequest: data })
        .then((res) => {
          notification.success({
            message: res?.message,
            description: res?.description,
          });
          history.push(`/supplier-invoice/${res.data.siid}`);
          setLoadingBtn(false);
        })
        .catch(() => {
          setLoadingBtn(false);
        });
    }
  };

  return (
    <DF.Provider pagcode="supplierinvoice" entity="SINVOICE" entityid={siid}>
      <Page
        modalTitle="Supplier Invoice details"
        showAsModal={showAsModal}
        visible={visible}
        onCancel={onCancel}
      >
        <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
          {siid && supplierInvoice?.cireference}
        </div>
        <Form
          layout="vertical"
          form={form}
          initialValues={INITIAL_VALUES}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row style={{ fontSize: '14px', fontWeight: 'bold' }}>
            <Col span={16}>
              {!showAsModal && (
                <ArrowLeftOutlined
                  onClick={() => {
                    history.push(`/supplier-invoice`);
                  }}
                  style={{
                    float: 'left',
                    margin: '0px 5px',
                    fontSize: 'larger',
                  }}
                />
              )}
              {siid ? (
                <>
                  <GetLabel label="SupplierInvoice" />
                  {' - ' +
                    supplierInvoice?.sireference +
                    ' - ' +
                    supplierInvoice?.suppliername}
                </>
              ) : (
                <Title level={4} comcode="NewSI"></Title>
              )}
            </Col>
            {!showButtons && (
              <Col span={8}>
                {tabPosition === 'left' ? (
                  <>
                    {isCreate || supplierInvoice?.sistatus === 'INIT' ? (
                      <Row gutter={2} justify="end">
                        <Col span={5}>
                          {Number(siid) ? (
                            <TasksListPopover
                              entityId={Number(siid)}
                              entityReference={supplierInvoice?.sireference}
                              entityName="SINVOICE"
                              title={
                                supplierInvoice?.sireference +
                                ' - ' +
                                supplierInvoice?.suppliername
                              }
                              onClose={() => {
                                setrefetechnetting(!refetechnetting);
                                refecthst();
                              }}
                            >
                              <Button comcode="actions" icon={<IActions />} />
                            </TasksListPopover>
                          ) : null}
                        </Col>

                        <Col span={8}>
                          <SaveButton
                            comcode="save"
                            custom={{ height: 52 }}
                            loading={loadingBtn}
                          />
                        </Col>
                      </Row>
                    ) : (
                      <Row gutter={2} justify="end">
                        <Col span={19}></Col>

                        <Col span={5}>
                          {Number(siid) ? (
                            <TasksListPopover
                              entityId={Number(siid)}
                              entityName="SINVOICE"
                              title={
                                supplierInvoice?.sireference +
                                ' - ' +
                                supplierInvoice?.suppliername
                              }
                              onClose={() => {
                                setrefetechnetting(!refetechnetting);
                                refecthst();
                              }}
                            >
                              <Button comcode="actions" icon={<IActions />} />
                            </TasksListPopover>
                          ) : null}
                        </Col>
                      </Row>
                    )}{' '}
                  </>
                ) : null}
              </Col>
            )}
          </Row>

          <WizardTabs
            entity="SINVOICE"
            entityid={siid ?? supplierInvoice?.siid}
            taskid={
              siid ? wizData?.taskidDisplay ?? 0 : wizData?.taskidCreate ?? 0
            }
            defaultTabs={['tabSupplierInvoice', 'tabSuppInvoiceLines']}
            tabs={{
              tabSupplierInvoice: (
                <TabSupplierInvoice
                  form={form}
                  sitype={supplierInvoice?.sitype}
                  refresh={refresh}
                />
              ),
              tabSuppInvoiceLines: (
                <Form.Item
                  noStyle
                  shouldUpdate={shouldUpdateCompare('simultiplecontracts')}
                >
                  {({ getFieldValue }) => (
                    <TabSuppInvoiceLines
                      form={form}
                      siid={siid}
                      ctrid={form.getFieldValue('ctrid') ?? 0}
                      simultiplecontracts={getFieldValue('simultiplecontracts')}
                    />
                  )}
                </Form.Item>
              ),
              tabSuppInvoiceSchedules: (
                <TabSuppInvoiceSchedules form={form} siid={siid} />
              ),
              tabAccounting: (
                <Accounting objectid={siid!} objecttype="SINVOICE" />
              ),
              tabImportInvoice: <TabImportInvoice form={form} />,
              tabSupplierInvoiceNetting: (
                <TabSupplierInvoiceNetting
                  refetchNetting={refetechnetting}
                  form={form}
                  siid={Number(siid)}
                />
              ),
              tabUpload: (
                <DocList
                  objectid={siid}
                  objecttype="SINVOICE"
                  categorie="DOC"
                />
              ),
            }}
            tabBarExtraContent={
              tabPosition === 'top' ? (
                siid ? (
                  <TasksListPopover
                    entityId={siid || 0}
                    entityName="SINVOICE"
                    title={
                      supplierInvoice?.sireference +
                      ' - ' +
                      supplierInvoice?.suppliername
                    }
                    onClose={refetch}
                  >
                    <Button
                      icon={<ThunderboltTwoTone twoToneColor="#eb2f96" />}
                      size="middle"
                      comcode="actions"
                    />
                  </TasksListPopover>
                ) : (
                  <SaveButton
                    comcode="save"
                    custom={{ height: 52 }}
                    loading={loadingBtn}
                  />
                )
              ) : null
            }
          />
        </Form>
      </Page>
    </DF.Provider>
  );
};

const INITIAL_VALUES: any = {
  sigrosstotal: 0,
  sinettotal: 0,
  sitaxtotal: 0,
  cidocdate: moment(),
  ctreference: null,
};

export default SIDetail;
